var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.adminLayoutContainer
  }, [_c('MottoSidebar', {
    attrs: {
      "sidebar-expanded": _vm.sidebarExpanded
    },
    on: {
      "collapse": _vm.collapseSidebar
    }
  }), _c('div', {
    style: {
      marginLeft: `${_vm.getLeftSpacingMargin}px`,
      marginTop: _vm.isMobile ? '120px' : '104px'
    }
  }, [_c('div', {
    class: [_vm.$style.adminHeader],
    style: {
      width: `calc(100% - ${_vm.getLeftSpacingMargin}px)`
    }
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "min-width": "133px"
    }
  }, [_c('MottoIcon', {
    class: _vm.$style.mobileHamburger,
    attrs: {
      "name": "Hamburger",
      "icon-color": "primary",
      "mobile-sidebar-hamburger": ""
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.expandSidebar.apply(null, arguments);
      }
    }
  }), _c('RouterLink', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    class: _vm.$style.headerLogo,
    attrs: {
      "src": require("@assets/images/mottocenter-new-logo-blue.png"),
      "alt": "Logo"
    }
  })])], 1), _c('div', {
    class: _vm.$style.searchContainer
  }, [_c('SearchResourceInput', {
    class: _vm.$style.searchBar
  })], 1), _c('div', {
    class: _vm.$style.profileContainer
  }, [_c('b-dropdown', {
    class: _vm.$style.notificationDropdown,
    attrs: {
      "size": "lg",
      "variant": "link",
      "no-caret": "",
      "right": "",
      "toggle-class": "text-decoration-none"
    },
    on: {
      "show": _vm.readAllNotifications
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('div', {
          class: _vm.$style.notificationIconContainer
        }, [_c('MottoIcon', {
          class: [_vm.$style.notificationIcon, _vm.unreadNotifications.length && !_vm.notificationsRead ? _vm.$style.notificationIconAnimation : ''],
          attrs: {
            "name": "Notification",
            "icon-color": "slate"
          }
        }), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.unreadNotifications.length && !_vm.notificationsRead,
            expression: "unreadNotifications.length && !notificationsRead"
          }],
          class: _vm.$style.notificationIconBadge
        }, [_vm._v(" " + _vm._s(_vm.unreadNotificationAmount) + " ")])], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    class: _vm.$style.notificationsContainer
  }, [_c('div', [_c('h3', [_vm._v("Notifications")])]), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_vm._l(_vm._.take(_vm.notifications, 10), function (notification) {
    return _c('NotificationInBell', {
      key: notification.id,
      attrs: {
        "notification": notification
      }
    });
  }), !_vm.notifications.length ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("You have no new notifications")]) : _vm._e()], 2)]), _c('p', {
    staticClass: "button-text text-center cursor-pointer mb-2 color-dark-gray",
    on: {
      "click": function () {
        return _vm.$router.push({
          name: 'notifications'
        });
      }
    }
  }, [_vm._v(" See all ")])]), _c('b-dropdown', {
    class: _vm.$style.profileDropdown,
    attrs: {
      "size": "lg",
      "variant": "link",
      "toggle-class": "text-decoration-none",
      "no-caret": "",
      "right": "",
      "data-profile-dropdown": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        var _vm$$route$meta;
        return [_c('ProfilePicture', {
          class: _vm.$style.profilePicture,
          attrs: {
            "hover-effect": "",
            "src": _vm.currentUser.photoUrl,
            "active": ((_vm$$route$meta = _vm.$route.meta) === null || _vm$$route$meta === void 0 ? void 0 : _vm$$route$meta.settingsMenu) === true
          }
        }), _c('p', {
          class: _vm.$style.profileName
        }, [_vm._v(_vm._s(_vm.getUserName))])];
      },
      proxy: true
    }])
  }, [_vm.hasPersonnelFeature && !_vm.canManagePersonnel ? _c('b-dropdown-item', {
    attrs: {
      "href": "/my-info"
    }
  }, [_c('div', {
    class: _vm.$style.profileDropdownIconContainer
  }, [_c('BaseIcon', {
    class: _vm.$style.profileDropdownIcon,
    attrs: {
      "name": "user"
    }
  })], 1), _vm._v(" Profile ")]) : _vm._e(), _vm.hasPersonnelFeature && _vm.canManagePersonnel ? _c('b-dropdown-item', {
    attrs: {
      "href": "/my-info"
    }
  }, [_c('div', {
    class: _vm.$style.profileDropdownIconContainer
  }, [_c('BaseIcon', {
    class: _vm.$style.profileDropdownIcon,
    attrs: {
      "name": "users"
    }
  })], 1), _vm._v(" Profile / Office Management ")]) : _vm._e(), _c('b-dropdown-item', {
    attrs: {
      "href": "/faq"
    }
  }, [_c('div', {
    class: _vm.$style.profileDropdownIconContainer
  }, [_c('MottoIcon', {
    class: _vm.$style.profileDropdownIcon,
    staticStyle: {
      "margin-left": "-4px"
    },
    attrs: {
      "name": "Help",
      "icon-color": "primary"
    }
  })], 1), _vm._v(" FAQ ")]), _c('b-dropdown-item', {
    attrs: {
      "href": "/mission-against-hunger"
    }
  }, [_c('div', {
    class: _vm.$style.profileDropdownIconContainer
  }, [_c('BaseIcon', {
    class: _vm.$style.profileDropdownIcon,
    attrs: {
      "name": "utensils"
    }
  })], 1), _vm._v(" Mission Against Hunger ")]), _c('b-dropdown-item', {
    attrs: {
      "href": "/security"
    }
  }, [_c('div', {
    class: _vm.$style.profileDropdownIconContainer
  }, [_c('BaseIcon', {
    class: _vm.$style.profileDropdownIcon,
    attrs: {
      "name": _vm.hasUserProfileFeature ? 'shield-halved' : 'gear'
    }
  })], 1), _vm._v(" Security Settings ")]), _vm.hasUserProfileFeature && !_vm.hasPersonnelFeature ? _c('b-dropdown-item', {
    attrs: {
      "href": "/profile"
    }
  }, [_c('div', {
    class: _vm.$style.profileDropdownIconContainer
  }, [_c('BaseIcon', {
    class: _vm.$style.profileDropdownIcon,
    attrs: {
      "name": "user"
    }
  })], 1), _vm._v(" Profile ")]) : _vm._e(), _vm.$store.getters['pwa/beforePwaInstallPrompt'] ? _c('b-dropdown-item', {
    on: {
      "click": _vm.installPwaApp
    }
  }, [_c('div', {
    class: _vm.$style.profileDropdownIconContainer
  }, [_c('MottoIcon', {
    class: _vm.$style.profileDropdownIcon,
    attrs: {
      "name": "Download",
      "icon-color": "primary"
    }
  })], 1), _c('span', {
    staticClass: "no-wrap"
  }, [_vm._v("Download App")])]) : _vm._e(), _vm.showEnableNotification() ? _c('b-dropdown-item', {
    on: {
      "click": _vm.requestPermissionPrompt
    }
  }, [_c('div', {
    class: _vm.$style.profileDropdownIconContainer
  }, [_c('MottoIcon', {
    class: _vm.$style.notificationDropdownIcon,
    attrs: {
      "name": "Notification",
      "icon-color": "primary"
    }
  })], 1), _c('span', {
    staticClass: "no-wrap"
  }, [_vm._v("Enable Notifications")])]) : _vm._e(), _c('b-dropdown-item', {
    attrs: {
      "href": "/logout"
    }
  }, [_c('div', {
    class: _vm.$style.profileDropdownIconContainer
  }, [_c('BaseIcon', {
    class: _vm.$style.profileDropdownIcon,
    attrs: {
      "name": "right-from-bracket"
    }
  })], 1), _vm._v(" Logout ")])], 1)], 1)]), _vm.isMobile ? _c('div', {
    staticClass: "d-block d-lg-none",
    class: _vm.$style.searchBarMobileContainer
  }, [_c('SearchResourceInput')], 1) : _vm._e(), _c('div', {
    class: _vm.$style.adminMainContentContainer
  }, [_c('div', {
    class: _vm.$style.sidebarRightSpacing
  }), _c('div', {
    ref: "adminMainContentWrapper",
    class: _vm.$style.adminMainContentWrapper
  }, [_vm._t("default")], 2)]), _c('div', {
    class: _vm.$style.legalInfoFooter
  }, [_c('div', {
    class: _vm.$style.sidebarRightSpacing
  }), _c('div', [_c('p', {
    staticClass: "tag-text color-gray"
  }, [_vm._v("©" + _vm._s(new Date().getFullYear()) + " MOTTO FRANCHISING, LLC. ALL RIGHTS RESERVED")]), _c('p', {
    staticClass: "tag-text color-gray"
  }, [_c('RouterLink', {
    attrs: {
      "to": {
        name: 'userAgreement'
      }
    }
  }, [_vm._v("User Agreement")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "https://www.mottomortgage.com/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" | "), _vm.hasSmsPromptsFeature ? [_c('RouterLink', {
    attrs: {
      "to": {
        name: 'mobileTerms'
      }
    }
  }, [_vm._v("Mobile Terms of Use")]), _vm._v(" | ")] : _vm._e(), _c('a', {
    attrs: {
      "href": "/"
    },
    on: {
      "click": _vm.openHelp
    }
  }, [_vm._v("Help")])], 2)])])]), _c('MottoFooter'), _vm.isMobile ? _c('ScrollToTopButton') : _vm._e(), _vm.pageHasSurvey ? _c('SurveyRider', {
    attrs: {
      "survey-question": _vm.currentSurvey
    }
  }) : _vm._e(), _vm.debugMode && _vm.debugOptions ? _c('DebugMode', {
    attrs: {
      "debug-options": _vm.debugOptions[_vm.$route.name]
    },
    on: {
      "update:debugOptions": function ($event) {
        return _vm.$set(_vm.debugOptions, _vm.$route.name, $event);
      },
      "update:debug-options": function ($event) {
        return _vm.$set(_vm.debugOptions, _vm.$route.name, $event);
      }
    }
  }) : _vm._e(), _c('ModalCourseReminder', {
    attrs: {
      "courses-notifications": _vm.courseReminderNotifications
    }
  }), _c('ProspectPromptHandler')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }